import { createHashRouter, useLocation } from 'react-router-dom';
import { commitSagas } from './saga';
import { checkRoutes, commitRoutes } from './router';
import { RootLayout } from './components/RootLayout';

/**
 * The router is defined here in a separate file due to timing and circular
 * dependency issues. Defining it in router.js or store.js caused issues due to
 * circular dependencies which occurred because the router imports RootLayout,
 * which is the root of the application, and some files within the application
 * then import router.js and store.js. This didn't always cause issues in
 * running the app, but caused test failures.
 */

const RouterRoot = () => {
  const location = useLocation();
  return <RootLayout location={location} />;
};

export const router = createHashRouter([
  { path: '/*', element: <RouterRoot /> },
]);

export const commitStore = () => {
  commitSagas();
  commitRoutes(router.state.location);
};

router.subscribe(({ location }) => {
  checkRoutes(location);
});

export const navigate = router.navigate;
